export default __webpack_public_path__ + "static/media/signature.bbf15af1.png";